module.exports = __webpack_public_path__ + "1a7a287b31a6901789b06d1b3b3dd499.svg";